import PropTypes from 'prop-types';
import React from 'react';
import { buildImagePath } from '../../../Content/User/UserDisplay/UserImage/UserImage';
import FGBLabel from '../../../Elements/FGBLabel/FGBLabel';
import CommonCardShell from '../../CommonCardShell/CommonCardShell';

import './TitleCard.scss';

export default class TitleCard extends React.PureComponent {
    renderSponsored = () => {
        const injectedTransforms = {
            small: 'c_scale,h_50',
        };
        const sponsorImage = buildImagePath(
            this.props.currentTopic.sponsored.src,
            'small',
            injectedTransforms
        );
        return (
            <a href={this.props.currentTopic.sponsored.url}>
                <div className="sponsorDisplay d-flex align-items-center justify-content-center">
                    <span className="sponsorText">Powered by</span>
                    <img className="sponsorLogo" src={sponsorImage} alt="" />
                </div>
            </a>
        );
    };

    render() {
        return (
            <div className="component-Layout-ThreeColumnGridLayout-TitleCard">
                <CommonCardShell>
                    <div className="titleSection">
                        <FGBLabel className="fgbLabel">
                            Fairygodboss Topics
                        </FGBLabel>

                        {this.props.currentTopic.sponsored
                            ? this.renderSponsored()
                            : null}
                        <div className="pageTitle">
                            {this.props.currentTopic.title}
                        </div>
                    </div>
                </CommonCardShell>
            </div>
        );
    }
}

TitleCard.propTypes = {
    currentTopic: PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        content: PropTypes.arrayOf(
            PropTypes.shape({
                type: PropTypes.string,
                number: PropTypes.number,
            })
        ),
        total: PropTypes.number,
        sponsored: PropTypes.shape({
            src: PropTypes.string.isRequired,
            alt: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        }),
        qaDataAttr: PropTypes.string,
    }).isRequired,
};
